// extracted by mini-css-extract-plugin
export default {"CommentBox":"IssueCommentEditor-module__CommentBox--fbuga","EditorMarginContainer":"IssueCommentEditor-module__EditorMarginContainer--vSuW7"};